globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.AdminTopBar = (function() {

  function AdminTopBar() {
    this.$AdminTopBar = $('.admin-top-bar');
    this.init();
  }

  AdminTopBar.toggleCookieName = '_sb.customer_space.admin_top_bar_toggled_off';

  AdminTopBar.prototype = {
    init: function(){
      var _this = this;

      $('.admin-top-bar .hidden').removeClass('hidden');

      _this.$AdminTopBar.on('click', '.admin-top-bar-toggle', function(){
        if(_this._topBarIsVisible()) {
          console.log('Hide');
          $('body').removeClass('has-admin-top-bar');
          utils.cookies.create(_this._toggleCookieName(), {});
        } else {
          console.log('Show');
          $("body").addClass('has-admin-top-bar');
          utils.cookies.delete(_this._toggleCookieName());
        }
      });
    },
    _topBarIsVisible: function(){
      return $('body').hasClass('has-admin-top-bar')
    },
    _toggleCookieName: function(){
      return AdminTopBar.toggleCookieName;
    }
  }

  return AdminTopBar;

})();
